import { useFormik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import TextInput from "../../common/textfield/TextInput";
import SelectFiled from "../../common/textfield/SelectFiled";
import { DateSelectorWithoutFormik } from "../../common/textfield/DateSelector";
import { genderOptions } from "./Constant";
import moment from "moment";
import Fields from "./Fields";
import CountrySelect from "../../common/textfield/CountrySelect";
import RegionSelect from "../../common/textfield/RegionSelect";
import { Button } from "../../common/Button";
import { createUser } from "../../api/Individual";
import { useClinicLocationsQuery } from "../../../hooks/ReactQueryHooks/useClinicLocationsQuery";
import { failed, success } from "../../common/Toastify";
import { decryptData, encryptData } from "../../EncryptDecrypt";
import { createContactNumber } from "../../../utils/phoneNumberSupport";
import { useOrgQuery } from "../../../hooks/ReactQueryHooks/useOrgQuery";
import ReactDatePicker from "../../common/textfield/ReactDatePicker";
import { createAccountOptions } from "../Individuals/Constants";
import { useSelector } from "react-redux";
import { getPatientByPersonId } from "../../apps/api/Patient";
import * as Yup from "yup";
import { useOrgHcnQuery } from "../../../hooks/ReactQueryHooks/useOrgHcnQuery";
import { getOrganizationSettings } from "../../api/Organization";
import { useGetOrgLicensedProducts } from "../../../hooks/ReactQueryHooks/useGetOrgLicensedProducts";
import { is } from "date-fns/locale";
import { Tooltip } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { validation, conditionalValidation } from "../../../utils/constants";

const AddPatient = ({ modalShow, formikInBoundCall, handleShow, getAddedPatient }) => {
  const [btnLoading, setBtnLoading] = useState(false);
  const [organizationsData, setOrganizationsData] = useState([]);
  const [generalPractitionerOptions, setGeneralPractitionerOptions] = useState([]);
  const [isClick, setIsClick] = useState(false);
  const userOrg = useSelector((state) => state?.auth?.user?.organizations)
  const userOrgId = userOrg?.[0]?.id;

  const [hcnList, setHcnList] = useState([]);
  const orgId = formikInBoundCall.values.orgId;
  const [enforceHCN, setEnforceHCN] = useState(false);
  const [enforceEmail, setEnforceEmail] = useState(false);
  const [enforcePhoneNumber, setEnforcePhoneNumber] = useState(false);
  const [enforceAddress, setEnforceAddress] = useState(false);
  const [enforceCountry, setEnforceCountry] = useState(false);
  const [enforceProvince, setEnforceProvince] = useState(false);
  const [enforceCity, setEnforceCity] = useState(false);
  const [enforcePostalCode, setEnforcePostalCode] = useState(false);
  const [enforceDOB, setEnforceDOB] = useState(false);
  const [enforceGender, setEnforceGender] = useState(false);
  const [enforceFirstName, setEnforceFirstName] = useState(false);
  const [enforceLastName, setEnforceLastName] = useState(false);
  const [loading, setLoading] = useState(false);
  const { data: orgLicensedProducts } = useGetOrgLicensedProducts({})
  const is_VirtualCareEnabled = orgLicensedProducts?.virtualCare
  const [createAccountValue, setCreateAccountValue] = useState(is_VirtualCareEnabled ? true : false);
  const onSuccessLocations = (data) => {
    setLocations(
      data?.map((location) => (location = { ...location, value: location?.id }))
    );
  };
  useClinicLocationsQuery({ onSuccess: onSuccessLocations });
  const [locations, setLocations] = useState([]);

  //Fetching Organization Data
  const onSuccessOrg = (data) => {

    setOrganizationsData(data);
  };

  useOrgQuery({ onSuccess: onSuccessOrg });

  const onSuccessHcn = (data) => {
    const hcnOptions = data
      ?.filter((hcn) => hcn.active)
      .sort((a, b) => a.description.localeCompare(b.description))
      .map((hcn) => ({
        ...hcn,
        value: hcn.authority === "#" ? `test-authority-${hcn.id}` : hcn.authority,
        name: hcn.display || hcn.description,
      }));

    setHcnList(hcnOptions);
  };
  useOrgHcnQuery({ onSuccess: onSuccessHcn, orgId: orgId });

  useEffect(() => {
    if (!orgId) return;
    setLoading(true);
    getOrganizationSettings(orgId)
      .then((res) => {
        if (res?.status) {
          const p = res.data?.patient || {};
          setEnforceHCN(!!p.hcn);
          setEnforceEmail(!!p.email);
          setEnforcePhoneNumber(!!p.phone);
          setEnforceCountry(!!p.country);
          setEnforceProvince(!!p.province);
          setEnforceCity(!!p.city);
          setEnforceFirstName(!!p.firstName);
          setEnforceLastName(!!p.lastName);
          setEnforceGender(!!p.gender);
          setEnforceDOB(!!p.dob);
          setEnforcePostalCode(!!p.postalCode);
          setEnforceAddress(!!p.address);
        }
      })
      .catch((res) => {
        failed(
          res?.response?.data?.message ||
          res?.response?.data?.error ||
          res.message
        );
      })
      .finally(() => setLoading(false));
  }, [orgId]);

  const formik = useFormik({
    initialValues: {
      orgId: "",
      orgName: "",
      first_name: "",
      last_name: "",
      date_of_birth: formikInBoundCall.values.date_of_birth || "",
      gender: "",
      country: "",
      city: "",
      region: "",
      address: "",
      postalCode: "",
      email: "",
      phone_number: "",
      general_practitioner: "",
      hcn: "",
      ext: "",
      create_account: "",
      healthCardAuthority: ""
    },
    validationSchema: Yup.object({
      //first_name: enforceFirstName ? Yup.string().max(30, "Must be 30 characters or less").required("Required first name field").matches(/^$|^\S+.*/, "Only blankspaces is not valid.") : Yup.string().max(30, "Must be 30 characters or less").matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
      first_name: conditionalValidation(
        Yup.string()
        .max(30, "Must be 30 characters or less"),
        { 
          validation, 
          mandatory: enforceFirstName,
          label: "First name" }),
      // last_name: enforceLastName ? Yup.string().max(30, "Must be 30 characters or less").required("Required last name field").matches(/^$|^\S+.*/, "Only blankspaces is not valid.") : Yup.string().max(30, "Must be 30 characters or less").matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
      last_name: conditionalValidation(Yup.string()
        .max(30, "Must be 30 characters or less"),
        {
          validation,
          mandatory: enforceLastName,
          label: "Last name"
        }),
      date_of_birth: enforceDOB // this stays as is, because DOB has custom validation.
            ? Yup.string()
                .required("Required date of birth field")
                .nullable()
                .test(
                  "valid-format",
                  "Invalid format. Use MMM-DD-YYYY (JAN-01-2024).",
                  function (value) {
                    if (value) { 
                      const isValid1 = moment(value, "MM/DD/YYYY", true).isValid();
                      const isValid2 = moment(value, "MM-DD-YYYY", true).isValid();
                      if (!isValid1 && !isValid2) return false; 
                      const dob = isValid1 ? moment(value, "MM/DD/YYYY") : moment(value, "MM-DD-YYYY"); 
                      if (dob.isAfter(moment())) {
                        return this.createError({
                          message: "Date of birth cannot be in the future.",
                        });
                      }
                      let minDate = moment().subtract(125, "years");
                      if (dob.isBefore(minDate)) {
                        return this.createError({
                          message: "Date of Birth cannot be more than 125 years ago.",
                        });
                      }
                    }
                    return true;
                  }
                )
            : Yup.string()
                .nullable()
                .test(
                  "valid-format",
                  "Invalid format. Use MMM-DD-YYYY (JAN-01-2024).",
                  function (value) {
                    if (!value) return true; 
                    const isValid1 = moment(value, "MM/DD/YYYY", true).isValid();
                    const isValid2 = moment(value, "MM-DD-YYYY", true).isValid();
                    if (!isValid1 && !isValid2) return false; 
                    const dob = isValid1 ? moment(value, "MM/DD/YYYY") : moment(value, "MM-DD-YYYY");  
                    if (dob.isAfter(moment())) {
                      return this.createError({
                        message: "Date of birth cannot be in the future.",
                      });
                    }
                    let minDate = moment().subtract(125, "years");
                    if (dob.isBefore(minDate)) {
                      return this.createError({
                        message: "Date of Birth cannot be more than 125 years ago.",
                      });
                    } 
                    return true;
                  }
                ),
      gender: conditionalValidation(
        Yup.string(),
        {
          validation,
          mandatory: enforceGender,
          label: "Gender"
        }),
      country: conditionalValidation(
        Yup.string(),
        {
          validation,
          mandatory: enforceCountry,
          label: "Country"}),
      region: conditionalValidation(
        Yup.string(),
        {
          validation,
          mandatory: enforceProvince,
          label: "State/Province"
        }),
      address: conditionalValidation(
        Yup.string(),
        {
          validation,
          mandatory: enforceAddress,
          label: "Address"}),
      postalCode: Yup.string().when(["type", "country"], (type, country, schema) =>
          conditionalValidation(
            country === "US"
              ? Yup.number()
                .typeError("Zip code must be a number")
              : Yup.string()
                .matches(
                  /^[A-Za-z]\d[A-Za-z] [0-9][A-Za-z]\d$/,
                  "Postal code must be in A1A 1A1 format."
                ),
              {
                validation,
                mandatory: enforcePostalCode,
                label: (country === "US")? "Zip code":"Postal code"})
      ),
      email: conditionalValidation(
        Yup.string().when("create_account", (type, schema) =>
          createAccountValue
          ? schema
            .email("Invalid email address")
            .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid.")
          : schema
          .email("Invalid email address")
        ),
        {
          validation,
          mandatory: enforceEmail || createAccountValue,
          label: "Email"}), 
      phone_number: conditionalValidation(
        Yup.string().matches(/^(?:\+?1[-. ]?)?\(?[0-9]\d{2}\)?[-. ]?\d{3}[-. ]?\d{4}$/, "Enter Valid Phone Number."),
        {
          validation,
          mandatory: enforcePhoneNumber,
          label: "Phone Number"
        }),

      city: conditionalValidation(
        Yup.string(),
        {
          validation,
          mandatory: enforceCity,
          label: "City"
        }),
      // general_practitioner: Yup.array(),
      // hcn: enforceHCN ? Yup.string().required("Patient Identifier is required when creating a patient.") : Yup.string(),
      // healthCardAuthority: enforceHCN ? Yup.string()
      //   .required("Required Identifier Type")
      //   .matches(/^$|^\S+.*/, "Only blankspaces is not valid.") : Yup.string(),
      hcn: conditionalValidation(
        Yup.string()
          .matches(/^\d+$/, "Patient Identifier must contain only numbers"),
        {
          validation,
          mandatory: enforceHCN,
          label: "Patient Identifier"
        }
      ), 
      
      healthCardAuthority: conditionalValidation(
          Yup.string().when("hcn", {
          is: (hcn) => hcn && hcn.length > 0,
          then: (schema) => schema
            .required("Identifier Type is required when Patient Identifier is provided")
            .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid."),
        }),
        { 
          validation,
          label: "Identifier Type" }),    
      ext: conditionalValidation(
        Yup.string().matches(/^\d{0,4}$/, "Must be 4 digits or less."),
        { validation }
      ),
      create_account: conditionalValidation(
        Yup.string(),
        {
          validation,
          mandatory: is_VirtualCareEnabled,
          label: "Create Account"
        })
    }),
    onSubmit: (values) => {
      const state = values?.region;
      let phoneNumber = createContactNumber(values).trim();
      const dob = encryptData(moment(values?.date_of_birth).format("MM-DD-YYYY"))
      // const generalPractitionersSelected = generalPractitionerData?.filter((data) => values?.general_practitioner?.includes(data.id));
      let encryptedData = {
        first_name: encryptData(values?.first_name.toLowerCase().trim()),
        last_name: encryptData(values?.last_name.toLowerCase().trim()),
        full_name: encryptData([values?.first_name.toLowerCase().trim(), values?.last_name.toLowerCase().trim()].join(" ")),
        address: encryptData(values?.address.trim()),
        date_of_birth: dob === "Invalid date" ? "" : dob,
        phone_number: encryptData(phoneNumber.trim()),
        postalCode: encryptData(values?.postalCode.toUpperCase().trim()),
        city: encryptData(values?.city.trim()),
        gender: encryptData(values?.gender),
        email: encryptData(values?.email?.toLowerCase().trim()),
        healthCardNumber: encryptData(values?.hcn.trim()),
        healthCardAuthority: values?.healthCardAuthority
      };
      setBtnLoading(true)
      values.type = "Patient"
      values.organization = values.orgId
      const selectedLocationData =
        locations?.filter(
          (location) => location?.id === values?.clinic_location
        )?.[0] || null;

      createUser(
        values,
        encryptedData,
        organizationsData,
        state,
        "Patient",
        [],
        selectedLocationData,
        userOrgId,
      ).then((res) => {
        if (res.status === true) {
          // Prefer using the data from createUser directly to avoid relying on
          // search/index delays when creating a new patient during an encounter.
          const userData = res?.data || {};

          // Derive the Patient id from the link, if present.
          const linkedPatientId =
            userData?.link?.[0]?.target?.reference?.split("/")?.[1];

          const createdPatient = {
            ...userData,
            id: linkedPatientId,
            resourceType: "Patient",
          };

          getAddedPatient(createdPatient);
          handleShow();
          success(res.message || "Patient created successfully!");
          setBtnLoading(false);
        } else {
          setBtnLoading(false)
          failed(res.error);
        }
      })
        .catch((res) => {
          console.log("error", res)
          let message = res?.response?.data?.message || res?.response?.data?.error || res?.message;
          failed(message);
        })
        .finally(() => setBtnLoading(false));
    },
  });

  const handleCreateAccountChange = useCallback((event) => {
    const value = event?.target?.value;
    if (value == "true") {
      setCreateAccountValue(true);
    }
    else {
      setCreateAccountValue(false);
    }
    formik?.setFieldValue("create_account", value);
  }, [formik, setCreateAccountValue]);

  const handleDateChange = (val) => {
    const isValidDate = moment(val, 'MMM-DD-YYYY').isValid()
    if (val == null || val == "") {
      formik.setFieldValue("date_of_birth", val || "");
    } else {
      if (isValidDate) {
        formik.setFieldValue("date_of_birth", val.format("YYYY-MM-DD"));
      } else {
        formik.setFieldError('date_of_birth', 'Invalid date format')
      }
    }
  };

  const handlePostalCodeChange = (e) => {
    const { value } = e.target;
    let spacedValue = value;
    if (formik?.values?.country !== "US") {
      // Remove spaces and non-alphanumeric characters
      const formattedValue = value.replace(/[^A-Za-z0-9]/g, "");
      // Add a space after every 3 letters
      spacedValue = formattedValue.replace(
        /^([A-Za-z0-9]{3})([A-Za-z0-9]+)/,
        "$1 $2"
      );
    }
    // Set the formatted value in the formik
    formik?.setFieldValue("postalCode", spacedValue);
  };

  useEffect(() => {
    formik.setFieldValue("orgName", formikInBoundCall.values.orgName)
    formik.setFieldValue("orgId", formikInBoundCall.values.orgId)
    formik.setFieldValue("hcn", formikInBoundCall.values.hcn)
    formik.setFieldValue("date_of_birth", formikInBoundCall.values.date_of_birth)
    formik.setFieldValue("first_name", formikInBoundCall.values.first_name || "")
    formik.setFieldValue("last_name", formikInBoundCall.values.last_name || "")
    const selfCall = formikInBoundCall.values.questionResponse.find(q => q.tag === "SELFCALLING").answer.find(o => o.option === "Yes" && o.answer == true) ? true : false;
    const phoneNumberAnswer = formikInBoundCall.values.questionResponse.find(q => q.tag === "TELEPHONE")?.answer || [];
    if(selfCall)
      formik.setFieldValue("phone_number", phoneNumberAnswer[0]?.answer || "")
  }, [])

  const handleExt = (event) => {
    let key = event.key;
    let regex = new RegExp("^[0-9]+$");
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  };
  return (
    <Modal
      show={modalShow}
      onHide={handleShow}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdropClassName
      backdrop={"static"}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Create Patient
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="custom-card p-4">
          <form className="common-form border-fields">
            <Row>
              <Col>
                <TextInput
                  keyField={"orgName"}
                  label={"Organization"}
                  formik={formik}
                  placeholder={"Organization"}
                  disabled={true}
                />
              </Col>
              {is_VirtualCareEnabled && <Col>
                <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
                    <SelectFiled
                    keyField={"create_account"}
                    label={"Create Account"}
                    formik={formik}
                    placeholder={"Create Account"}
                    options={createAccountOptions}
                    onChange={handleCreateAccountChange}
                  />
                  { createAccountValue && <div>
                    <Tooltip title="If `Yes` is selected, the patient's email becomes mandatory. A temporary password will be sent to the provided email for mobile app access." componentsProps={{ tooltip: { sx: { fontSize: "1.5rem" } } }}>
                        <InfoOutlined style={{ color: "#666", cursor: "pointer" }} />
                    </Tooltip>
                  </div>
                  }
                </div>
              </Col>}
            </Row>
            <Row>
              <Col>
                <TextInput
                  keyField={"first_name"}
                  label={"First Name"}
                  formik={formik}
                  placeholder={"First Name"}
                  required={enforceFirstName}
                  hideRequired={!enforceFirstName}
                />
              </Col>
              <Col>
                <TextInput
                  keyField={"last_name"}
                  label={"Last Name"}
                  formik={formik}
                  placeholder={"Last Name"}
                  required={enforceLastName}
                  hideRequired={!enforceLastName}
                />
              </Col>
              <Col>
                <ReactDatePicker
                  keyField={"date_of_birth"}
                  label={"Date of Birth"}
                  formik={formik}
                  placeholder={"Select Date"}
                  hasValue={formik?.values?.["date_of_birth"]}
                  displayAge={formik.errors.date_of_birth ? false : true}
                  required={enforceDOB}
                  hideRequired={!enforceDOB}
                />
                {/* {formik.values.date_of_birth !== "" && <p style={{ fontSize: '12px',color:"black" }}>{safeAgeString(formik.values.date_of_birth)}</p>} */}
              </Col>
              <Col>
                <SelectFiled
                  keyField={"gender"}
                  label={"Select Gender"}
                  formik={formik}
                  options={genderOptions}
                  required={enforceGender}
                  hideRequired={!enforceGender}
                  selectDisabledValue={true}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <TextInput
                  keyField={"hcn"}
                  label={"Patient Identifier"}
                  formik={formik}
                  placeholder={"Patient Identifier"}
                  required={enforceHCN}
                  hideRequired={!enforceHCN}
                />
              </Col>
              <Col>
                <SelectFiled
                  keyField={"healthCardAuthority"}
                  label={"Identifier Type"}
                  formik={formik}
                  options={hcnList}
                  required={enforceHCN}
                  hideRequired={!enforceHCN}
                  selectDisabledValue={true}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <CountrySelect
                  keyField={"country"}
                  label={"Country"}
                  formik={formik}
                  required={enforceCountry}
                  hideRequired={!enforceCountry}
                />
              </Col>
              <Col>
                <RegionSelect
                  defaultOptionLabel={
                    formik?.values?.country === "US"
                      ? "Select State"
                      : "Select Province"
                  }
                  keyField={"region"}
                  label={
                    formik?.values?.country === "US" ? "State" : "Province"
                  }
                  formik={formik}
                  required={enforceProvince}
                  hideRequired={!enforceProvince}
                />
              </Col>
              <Col>
                <TextInput
                  keyField={"city"}
                  label={"City"}
                  formik={formik}
                  placeholder={"city"}
                  required={enforceCity}
                  hideRequired={!enforceCity}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <TextInput
                  keyField={"address"}
                  label={"Address"}
                  formik={formik}
                  placeholder={"Address"}
                  required={enforceAddress}
                  hideRequired={!enforceAddress}
                />
              </Col>
              <Col>
                <TextInput
                  onChange={handlePostalCodeChange}
                  keyField={"postalCode"}
                  label={
                    formik?.values?.country === "US"
                      ? "Zip Code"
                      : "Postal Code"
                  }
                  formik={formik}
                  placeholder={
                    formik?.values?.country === "US"
                      ? "Zip Code"
                      : "Postal Code"
                  }
                  maxLength={formik?.values?.country === "US" ? "5" : "7"}
                  required={enforcePostalCode}
                  hideRequired={!enforcePostalCode}
                />
              </Col>
              <Col>
                <TextInput
                  keyField={"email"}
                  label={"Email Address"}
                  formik={formik}
                  placeholder={"Email Address"}
                  hideRequired= {!enforceEmail}
                  required={enforceEmail}
                />
                
              </Col>
            </Row>
            <Row>

              <Col>
                <TextInput
                  keyField={"phone_number"}
                  type="phone"
                  label={"Phone Number"}
                  formik={formik}
                  placeholder={"Phone Number"}
                  required={enforcePhoneNumber}
                  hideRequired={!enforcePhoneNumber}
                />
              </Col>
              <Col>
                <TextInput
                  keyField={"ext"}
                  label={"Ext."}
                  type="text"
                  maxlength="4"
                  formik={formik}
                  placeholder={"Ext."}
                  required={false}
                  onKeyPress={handleExt}
                  autocomplete="off"
                />
              </Col>
            </Row>
            {/* {formik?.values?.region && <Row>
            <Col>
              <MultiSelect
                options={generalPractitionerOptions?.map((option) => ({
                  ...option,
                  disabled: true,
                  checked: defaultAssignedPractitioner?.includes(option?.value),
                }))}
                keyField={"general_practitioner"}
                formik={formik}
                label={"Assign Practitioner"}
                nodata={"No Data Found"}
                required={false}
                defaultValue={defaultAssignedPractitioner}
                isSelectAll={defaultAssignedPractitioner?.length === generalPractitionerOptions?.length}
                isSelectAllEnable={false}
                />
                </Col>
            </Row>} */}
            <div className="btn-wrap" style={{ display: "flex", gap: "16px" }}>
              <Button type="button" isLoading={btnLoading} onClick={() => [formik.handleSubmit(), setIsClick(true)]}>
                Create
              </Button>
              <Button
                onClick={() => !btnLoading && handleShow()}
                variant="secondary"
              >
                Cancel
              </Button>
            </div>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddPatient;
